import { useState, useEffect } from 'react';
import authService from '../services/auth';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = () => {
      try {
        const isValid = authService.isAuthenticated();
        setIsAuthenticated(isValid);
        
        if (isValid) {
          setUser({ 
            clientId: localStorage.getItem('welliemd_client_id'),
            role: 'patient' 
          });
        }
      } catch (error) {
        console.error('Auth check failed:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const authenticateForQuestionnaire = async (templateId, patientId) => {
    try {
      setLoading(true);
      const tokenData = await authService.authenticateWithPKCE(templateId, patientId);
      
      if (tokenData.access_token) {
        setIsAuthenticated(true);
        setUser({ 
          clientId: localStorage.getItem('welliemd_client_id'),
          role: 'patient',
          questionnaire_session: tokenData.questionnaire_session
        });
        return { success: true, tokenData };
      } else {
        return { success: false, error: 'No access token received' };
      }
    } catch (error) {
      console.error('PKCE authentication failed:', error);
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    authService.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    user,
    loading,
    authenticateForQuestionnaire,
    logout
  };
};
